import { supabase } from './supabaseClient';

export const trackEvent = async (event, metadata = {}) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    
    await supabase.from('analytics').insert({
      user_id: user.id,
      event,
      metadata
    });
  } catch (err) {
    // Не блокуємо UI якщо аналітика не працює
    console.warn('Analytics error:', err);
  }
};
